module.exports = __webpack_public_path__ + "img/Menopause.45ebb3e9.png";